<ng-select class="searchable-select-panel"
           [items]="items"
           [bindLabel]="bindLabel"
           [bindValue]="bindValue"
           [searchable]="searchable"
           [clearable]="clearable"
           [loading]="loading"
           [loadingText]="loadingText"
           [notFoundText]="notFoundText"
           [placeholder]="placeholder"
           [disabled]="disabled"
           [trackByFn]="trackByFn"
           [compareWith]="compareWith"
           [ngModel]="value"
           appendTo="body"
           (ngModelChange)="onModelChange($event)"
           (blur)="onBlur()">
  <ng-content></ng-content>
</ng-select>
